import React from "react";
import type { IconProps } from "./icon.types";

export function EditImage({ size = 24, ...props }: IconProps): React.ReactElement {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M20.998 6.25A3.25 3.25 0 0 0 17.748 3H6.25A3.25 3.25 0 0 0 3 6.25v11.499a3.25 3.25 0 0 0 3.25 3.25h4.914l.356-1.424l.02-.076H6.25q-.308-.001-.582-.1l5.807-5.685l.083-.07a.75.75 0 0 1 .966.07l2.079 2.036l1.06-1.06l-2.09-2.048l-.128-.116a2.25 2.25 0 0 0-3.02.116l-5.822 5.7a1.8 1.8 0 0 1-.103-.593v-11.5c0-.966.783-1.75 1.75-1.75h11.499c.966 0 1.75.784 1.75 1.75v4.983c.478-.19.993-.264 1.5-.22zm-3.495 2.502a2.252 2.252 0 1 0-4.504 0a2.252 2.252 0 0 0 4.504 0m-3.004 0a.752.752 0 1 1 1.504 0a.752.752 0 0 1-1.504 0m4.6 3.917l-5.902 5.901a2.7 2.7 0 0 0-.707 1.248l-.457 1.83c-.2.797.522 1.518 1.318 1.319l1.83-.458a2.7 2.7 0 0 0 1.248-.706L22.33 15.9a2.286 2.286 0 0 0-3.233-3.232" />
    </svg>
  );
}
